import React, { useState, useEffect } from "react";
import * as metrics from "../../../CatalogMetrics/operations";
import * as categories from "../../../CatalogCategories/operations";
import * as clients from "../../../CatalogClients/operations";

import { ClientEditModal as MetricModal } from "../../../CatalogMetrics/editModal";
import { ClientEditModal as CategoryModal } from "../../../CatalogCategories/editModal";
import { useSelector } from "react-redux";

import { Container, Card } from "react-bootstrap";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import { toAbsoluteUrl, resizedataURL } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useToasts } from "react-toast-notifications";

import { useHistory, useLocation, useParams } from "react-router-dom";
import * as crud from "../../operations";
import { Formik, Form, Field } from "formik";
import { uniqueId } from "lodash-es";

const Schema = Yup.object().shape({
  name: Yup.string()
    .max(50, "Maximum 50")
    .required("Name is required"),
  volume: Yup.number()
    .min(0, "Minimum 1")
    .required("Volume is required"),
  metric: Yup.string().optional(),
  code: Yup.string()
    .max(50, "Maximum 50")
    .optional(),
  cost: Yup.number()
    .min(0, "0 is minimum")
    .required("cost is required"),
  price: Yup.number()
    .min(0, "$0.001 is minimum")
    .max(1000000, "$1000000 is maximum")
    .required("SRP is required"),
  category: Yup.string().optional(),
  description: Yup.string().optional("Description is required"),
});


const NewCompetionProduct = ({
  update,
  document: product,
  actionsLoading,
  handleClose,
}) =>  {
  const { user } = useSelector((state) => state.auth);
  const userDocument = user.uid ? user : user.payload;

  const history = useHistory();


  const [AVAILABLE_MANUFACTURES, setAvailable] = useState([]);
  const [AVAILABLE_CATEGORIES, setCategories] = useState([]);
  const [AVAILABLE_METRICS, setMetrics] = useState([]);



  useEffect(() => {
    clients.getClient("").then(({ data }) => {
      const clients = data.payload;
      console.log(clients);
      setAvailable(clients);
    });
    categories.getClient("").then(({ data }) => {
      setCategories(data.payload);
    });
    metrics.getClient("").then(({ data }) => {
      setMetrics(data.payload);
    });
  }, []);


  const { addToast } = useToasts();

  const [image, setImage] = useState(product.image || "");

  function updatePhoto({ target }) {
    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      ({ target }) => {
        resizedataURL(target.result, 600, 600).then((data) => {
          setImage(data);
        });
      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  const [isSubmitting, setSubmitting] = useState(false);
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const [showCategory, setShowCategory] = useState(false);
  const handleCategory = (document) => {
    categories.updateClient(document).then(() => {
      categories.getClient().then(({ data }) => {
        addToast(process.env[`REACT_APP_${"create".toUpperCase()}`], {
          appearance: "success",
        });

        setCategories(data.payload);
        setShowCategory(false);
      });
    });
  };

  const [showMetric, setShowMetric] = useState(false);
  const handleMetric = (document) => {
    metrics.updateClient(document).then(() => {
      metrics.getClient().then(({ data }) => {
        addToast(process.env[`REACT_APP_${"create".toUpperCase()}`], {
          appearance: "success",
        });

        setMetrics(data.payload);
        setShowMetric(false);
      });
    });
  };
  return (
    <>
      <MetricModal
        update={handleMetric}
        show={showMetric}
        handleClose={() => setShowMetric(false)}
        client={{}}
      />
      <CategoryModal
        update={handleCategory}
        show={showCategory}
        handleClose={() => setShowCategory(false)}
        client={{}}
      />
      <Formik
        enableReinitialize={true}
        initialValues={document}
        validationSchema={Schema}
        onSubmit={(values) => {
          if (!values.category_uid) {
            const [tmp] = [...AVAILABLE_CATEGORIES];
            values.category_uid = tmp.uid;
          }
          if (!values.metric_uid) {
            const [tmp] = [...AVAILABLE_METRICS];
            values.metric_uid = tmp.uid;
          }
          const [category_tmp] = [...AVAILABLE_CATEGORIES].filter(
            (c) => c.uid === values.category_uid
          );
          if (category_tmp) {
            values.category = category_tmp.name;
          }

          const [metric_tmp] = [...AVAILABLE_METRICS].filter(
            (m) => m.uid === values.metric_uid
          );
          if (metric_tmp) {
            values.metric = metric_tmp.sufix;
          }


          const competition =product.uid
           
          

          const doc = {
            product,
            competition,
            ...values,

            client: userDocument.company_id,
            image,
            manufacture: userDocument.company_id,
          };
          crud
            .updateClient(doc)
            .then(() => {
              history.push({
                 pathname: `/products/${product.uid}`
              });
            })
            .catch((err) => {
              setSubmitting(false);
            });
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >

        {({ handleSubmit, errors, handleChange, handleBlur }) => (
          <>
            <Card.Body className="cursor-default" size="lg">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form">
                <div className="row">
                  <div className="col-lg-3">
                    <h6>Image</h6>
                    <div className="col-lg-4 col-xl-6">
                      <div
                        className="image-input image-input-outline"
                        id="kt_profile_avatar"
                      >
                        <div
                          className="image-input-wrapper"
                          style={{
                            backgroundImage: `url(${image})`,
                          }}
                        ></div>
                        <label
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Change avatar"
                        >
                          <i className="fa fa-pen icon-sm text-muted"></i>
                          <input
                            type="file"
                            name="profile_avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={updatePhoto}
                          />
                          <input type="hidden" name="profile_avatar_remove" />
                        </label>
                        <span
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="cancel"
                          data-toggle="tooltip"
                          title="Cancel avatar"
                        >
                          <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span>
                      </div>
                      <span className="form-text text-muted">
                        Allowed file types: png, jpg, jpeg.
                      </span>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="form-group row">
                      <div className="col-lg-12">
                        <Field
                          name="name"
                          component={Input}
                          placeholder="Product Name"
                          label="Item Name"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          type="number"
                          name="cost"
                          component={Input}
                          placeholder="Cost"
                          label="Cost ($)"
                          customFeedbackLabel="Please enter Cost"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <Field
                          type="number"
                          name="price"
                          component={Input}
                          placeholder="SRP"
                          label="SRP"
                          customFeedbackLabel="Please enter SRP"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="volume"
                          type="number"
                          component={Input}
                          placeholder="volume"
                          label="volume"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <div className="d-flex justify-content-between">
                          <label>Select Metric</label>
                          <div
                            style={{ marginTop: "-10px" }}
                            title="Add region"
                            className="btn btn-icon btn-light btn-hover-success btn-sm align-top"
                            onClick={() => {
                              setShowMetric(true);
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-success">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/General/Size.svg"
                                )}
                              />
                            </span>
                          </div>
                        </div>
                        <Select name="metric_uid">
                          {AVAILABLE_METRICS.map((c) => (
                            <option key={c.uid} value={c.uid}>
                              {c.sufix}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="code"
                          component={Input}
                          placeholder="Internal Code / UPC"
                          label="Internal Code / UPC"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <div className="d-flex justify-content-between">
                          <label>Select Category</label>
                          <div
                            style={{ marginTop: "-10px" }}
                            title="Add region"
                            className="btn btn-icon btn-light btn-hover-success btn-sm align-top"
                            onClick={() => {
                              setShowCategory(true);
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-success">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Files/Folder.svg"
                                )}
                              />
                            </span>
                          </div>
                        </div>
                        <Select name="category_uid">
                          {AVAILABLE_CATEGORIES.map((c) => (
                            <option key={c.uid} value={c.uid}>
                              {c.name}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-12">
                        <Field
                          name="description"
                          component={Input}
                          label="description"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Card.Body>
            <Card.Footer>
              <button
                type="button"
                onClick={() => {
                  history.push({
                    pathname: `/products/${product.uid}`,
                  });
                }}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true);
                  handleSubmit();
                  setTimeout(() => setSubmitting(false), 2000);
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ? (
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            </Card.Footer>
          </>
        )}
      </Formik>
      </>
  );
}
export default function LocationWrapper(props) {
  const [document, setDocument] = useState({});
  const location = useLocation();
  const {uid} = useParams()

  console.log(uid)
  // const [favorite, setFavorite] = useState(false)

  useEffect(() => {
    if (uid) {
      crud.getClient(uid).then(({ data }) => {
        setDocument({ uid, ...data.payload });
        // //console.log({ uid, ...data.payload })
      });
    }
  }, [uid, location]);


  return (
    <Container>
      <Card>
        <Card.Header>
          New Product Competion for
          <h1 className="text-primary">{document.name}</h1>
        </Card.Header>
        <NewCompetionProduct {...{ props, document }} />
      </Card>
    </Container>
  );
}
